module.exports = __webpack_public_path__ + "static/media/android3.26775585.jpg";